import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import QrReader from 'react-qr-reader';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
// import Link from '@material-ui/core/Link';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import BackButton from '../../components/atoms/BackButton';
import { isAuthenticated } from '../../auth/Auth';
import MenuBox from '../../components/MenuBox';
import { getUserToken } from '../../actions/Users';
import ProgressDialogQR from '../../components/molecules/ProgressDialogQR';
import { nameSystem } from '../../constants/TextSystem';

const styles = theme => ({
  root: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  pageTitleDiv: {
    padding: '20px 15px 15px 15px',
    textAlign: 'left',
    backgroundColor: '#F7F7F7'
  },
  mainPaper: {
    position: 'relative',
    margin: '15px 15px 39px 15px'
  },
  textTitle: {
    fontFamily: '"Helvetica", "Arial", sans-serif',
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: '28px',
    paddingBottom: 20
  },
  textExplan: {
    fontSize: 14,
    fontWeight: 'normal',
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  contentDiv: {
    padding: '25px 20px'
  },
  stripeBtnDiv: {
    paddingLeft: 17,
    paddingTop: 25,
    paddingBottom: 14
  },
  detailTable: {
    width: 'auto'
  },
  boldText: {
    fontWeight: 'bold',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 16
  },
  boldRed: {
    fontSize: 14,
    fontWeight: 500,
    color: '#FF0000'
  },
  textLink: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  linkDiv: {
    paddingLeft: 20,
    paddingTop: 14,
    paddingBottom: 14
  },
  paddingTop9px: {
    padding: '9px 0 0 0 '
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getUserToken
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('token', 'setToken', ''),
  withState('code', 'setCode', ''),
  withState('suffixes', 'setSuffixes', ''),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    name,
    openDrawer,
    updateOpenDrawer,
    handleRedirect,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    token,
    setToken,
    code,
    setCode,
    suffixes,
    setSuffixes
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const shopId = typeof account !== 'undefined' ? account.shopId : null;
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const urlGochiWeb = process.env.REACT_APP_GOCHI_WEB_APP;
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;

    const getSiteType = acc => {
      let site = '';

      if (typeof acc !== 'undefined' && acc.fukuokaFlag === 1) {
        if (acc.educateSystem === nameSystem.suita) {
          site = `&siteType=suita`;
        } else if (acc.educateSystem === nameSystem.nishiwaki) {
          site = `&siteType=nishiwaki`;
        } else {
          site = `&siteType=fukuoka`;
        }
      }

      return site;
    };

    const siteType = getSiteType(account);

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }
    const backAction = () => handleRedirect('/home');

    const getToken = data => {
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .getUserToken(data)
        .then(response => {
          console.log('response', response.payload);
          if (urlGochiWeb && response.payload.status === 200) {
            setToken(response.payload.data.accessToken);
            setCode(data.qrCode);
            setSuffixes(response.payload.data.suffixes);
            setResultMessage(
              isFukuoka
                ? 'QRコードを読み込みました。<br/>クーポンの利用に進みます。'
                : 'QRコードを読み込みました。<br/>メニューの消し込みに進みますか。'
            );
          } else if (urlGochiWeb && response.payload.status === 500) {
            setToken('');
            setResultMessage('エラーが発生しました');
          } else if (
            urlGochiWeb &&
            response.payload.status === 400 &&
            response.payload.data.errorInfo.code ===
              'exception.errors.not.found.resource'
          ) {
            setToken('');
            setResultMessage('この会員証は正しくありません。');
          } else if (
            urlGochiWeb &&
            response.payload.status === 409 &&
            response.payload.data &&
            response.payload.data.errorInfo &&
            response.payload.data.errorInfo.content
          ) {
            setToken('');
            setResultMessage(response.payload.data.errorInfo.content);
          } else {
            setToken('');
            setResultMessage('エラーが発生しました');
          }
          updateLoading(false);
        })
        .catch(() => {
          setToken('');
          setResultMessage('エラーが発生しました');
          updateLoading(false);
        });
    };

    const handleErrorQRCode = () => {
      setResultMessage('エラーが発生しました');
    };

    const handleScanQRCode = data => {
      if (data && !openProgress) {
        getToken({ qrCode: data });
      }
    };

    const progressOkAction = () => {
      if (token && code && suffixes === 'GU') {
        window
          .open(
            `${urlGochiWeb}/qrCode?shopId=${shopId}&accessToken=${token}&accessCode=${code}${siteType}`,
            '_blank'
          )
          .focus();
      } else if (token && code && suffixes === 'GC') {
        window
          .open(
            `${urlGochiWeb}/mypage/kodomo_use?shopIdQr=${shopId}&accessToken=${token}&accessCode=${code}${siteType}`,
            '_blank'
          )
          .focus();
      }
      updateOpenProgress(false);
    };

    const progressCancelAction = () => {
      updateOpenProgress(false);
    };

    return (
      <div className={classes.root}>
        <Header
          name={name}
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitleDiv}>
          <Typography
            className={`${classes.textTitle} ${
              isFukuoka ? classes.paddingTop9px : ''
            }`}
          >
            {isFukuoka ? 'カード読取' : '会員証読込'}
          </Typography>
          {/* <Typography className={classes.textExplan}></Typography> */}
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div>
            <div>
              <QrReader
                // ref="qrReader1"
                delay={300}
                onError={() => handleErrorQRCode}
                onScan={handleScanQRCode}
                style={{ width: '100%' }}
                // legacyMode={this.state.legacyMode}
              />
            </div>
            <BackButton onClickAction={backAction} />
          </div>
        </Paper>
        <MenuBox account={account} />
        <ProgressDialogQR
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          progressCancelAction={progressCancelAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
